<h2 class="template-title" mat-dialog-title>Template Editor</h2>
<mat-dialog-content class="template-container mat-elevation-z8">

  <div>
    <mat-label>Name</mat-label>
    <br>
    <input matInput [(ngModel)]="template.name" />
  </div>

  <div style="width: 100%">
    <mat-label>Description</mat-label>
    <br>
    <textarea
      matInput
      [(ngModel)]="template.description"
      rows="4"
      spellcheck="false"
      style="font-family: monospace; width: 100%"
    ></textarea>
  </div>

  <div style="width: 100%">
    <mat-label>Type</mat-label>
    <br>
    <mat-select [(ngModel)]="selectedTemplateType">
      <mat-option *ngFor="let type of templateTypes" [value]="type">
        {{ type.name }}
      </mat-option>
    </mat-select>
  </div>

  <div style="width: 100%">
    <mat-label>Match Test (regex)</mat-label>
    <br>
    <textarea
      matInput
      [(ngModel)]="template.test"
      rows="2"
      spellcheck="false"
      style="font-family: monospace; width: 100%"
    ></textarea>
  </div>

  <ng-container *ngIf="selectedTemplateType.name == 'Extractor'">
    <div style="width: 100%">
      <mat-label>Extractor JavaScript</mat-label>
      <br>
      <textarea
        matInput
        [(ngModel)]="template.eval"
        rows="4"
        spellcheck="false"
        style="font-family: monospace; width: 100%"
      ></textarea>
    </div>
  </ng-container>

  <div class="error-msg" *ngIf="errorMsg.length > 0">
    {{errorMsg}}
  </div>

   <mat-divider></mat-divider>

    <div style="width: 100%">
      <mat-label>Log Sample</mat-label>
      <br>
      <textarea
        matInput
        [(ngModel)]="sample"
        rows="4"
        spellcheck="false"
        style="font-family: monospace; width: 100%"
      ></textarea>
    </div>

    <div *ngIf="sample.length > 0">
      <div style="width: 100%">
        <span>Matched: </span><span style="font-weight: bold" [ngStyle]="{ color: isMatched ? 'green' : 'red' }">{{ isMatched }}</span>
        <span class="eval-value-label " *ngIf="selectedTemplateType.name == 'Extractor'">Value: </span><span *ngIf="selectedTemplateType.name == 'Extractor'">{{ extractedValue }}</span>
      </div>
      <div style="width: 100%" class="eval-msg">
        {{ evalMsg }}
      </div>
    </div>

</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button class="action-btn cancel-btn" (click)="onCancel()">Cancel</button>
  <button mat-button class="action-btn ok-btn" color="primary" (click)="onConfirm()" [disabled]="!isFormValid()">OK</button>
</mat-dialog-actions>
